import React, { useState, useEffect, useContext } from 'react';
import '../../css/home/home.css'; // Asegúrate de crear este archivo CSS también
import ButtonHomeTransaction from '../../components/button/ButtonHomeTransaction'
import ButtonWalletCripto from '../../components/button/ButtonWalletCripto'
import ButtonWalletAdd from '../../components/button/ButtonWalletAdd'
import CardWalletBalance from '../../components/card/CardWalletBalance'
import CustomTable from '../../components/table/CustomTable';
import axios from 'axios';
import moment from 'moment';
import { AuthContext } from '../../context/AuthContext';

import COPU from '../../assets/currency/copu.png'
import USD from '../../assets/currency/usd.png'
import BRL from '../../assets/country/brasil.png'
import MXN from '../../assets/country/mexico.png'

import { IoIosArrowRoundDown } from "react-icons/io";
import { TbTransfer } from "react-icons/tb";
import { FormatMontoPSE } from '../../utils/Utils'

import ModalDepositar from '../../components/modal/modalTransaction/ModalDepositar';
import ModalExchange from '../../components/modal/modalTransaction/ModalExchange'
import ModalSend from '../../components/modal/modalTransaction/modalSend'
import ModalReceibe from '../../components/modal/modalTransaction/modalReceibe'
import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';


const MyWallet = () => {
  const location = useLocation();
  const currency = location.state?.currency;

  const [activeExchange, setActiveExchange] = useState(false)
  const [activeSend, setActiveSend] = useState(false)
  const [Recibe, setRecibe] = useState(false)
  console.log("state,state", currency);

  const [balanceWalletUsd, setBalanceWalletUsd] = useState('')
  const [balanceWalletCop, setBalanceWalletCop] = useState('')
  const [balanceTotalCop, setBalanceTotalCop] = useState('')
  const [activeDepositar, setActiveDepositar] = useState(false)
  const [currencyCoin, setCurrencyCoin] = useState(currency === "USD" ? 'USD' : "COP")

  const [LoadingTable, setLoadingTable] = useState('')
  const [LoadingTableSkeleton, setLoadingTableSkeleton] = useState(true)
  const { getAuthenticatedHeaders } = useContext(AuthContext);
  const [TotalRows, setTotalRows] = useState('')
  const [DataTable, setDataTable] = useState([])

  const [LoadingBalance, setLoadingBalance] = useState(true)

  const [data, setData] = useState([])
  const [dataAmount, setDataAmount] = useState([])


  const agregarImagenes = () => {
    const imagesByCode = {
      COP: COPU,
      USD: USD,
      MXN: MXN,
      BRL: BRL

    };
    console.log("veamos", data.map(item => item.code));

    setData(prevData =>
      prevData.map(item => ({
        ...item,
        image: imagesByCode[item.code] || null
      }))
    );
  };

  const MovementsList = async () => {
    setLoadingTable(true)
    try {
      const response = await axios.post(`/api/movements`, {
        headers: await getAuthenticatedHeaders(),
        page: 1,
        currency: currencyCoin
      });
      setTotalRows(response.data?.data?.total_items)
      setDataTable(response.data?.data?.items)

    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
    setLoadingTable(false)
    setLoadingTableSkeleton(false)

  };
  const CurrencyCoin = async () => {
    setLoadingTable(true)
    try {
      const response = await axios.post(`/api/wallet_currency`, {
        headers: await getAuthenticatedHeaders(),
      });
      console.log("setData", response.data.data);

      setData(response.data.data)
      agregarImagenes()
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
    setLoadingTable(false)
    setLoadingTableSkeleton(false)

  };
  const BalanceWalletCredit = async () => {
    setLoadingTable(true)
    try {
      const response = await axios.post(`/api/wallet_balance`, {
        headers: await getAuthenticatedHeaders(),
        coin: currencyCoin
      });
      console.log("balance", response);

      setDataAmount(response.data.data.data)

    } catch (error) {

    }
    setLoadingTable(false)
    setLoadingTableSkeleton(false)

  };

  const WalletBalanceHome = async () => {
    setLoadingBalance(true)
    try {
      const response = await axios.post(`/balance/wallet_home`, {
        headers: await getAuthenticatedHeaders(),
        currency: "USD"
      });

      const balances = response?.data?.data?.balances;
      const copBalance = balances?.find(item => item.currency_code === "COP")?.balance || "0.00";
      const usdBalance = balances?.find(item => item.currency_code === "USD")?.balance || "0.00";

      setBalanceWalletUsd(usdBalance)
      setBalanceWalletCop(copBalance);
      setBalanceTotalCop(response.data.data.balance_total);

    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
    setLoadingBalance(false)

  };
  const OpenDepositar = () => {

    setActiveDepositar(true)
  }
  const OpenReceibe = () => {

    setRecibe(true)
  }
  const columns = [

    {
      name: 'Actividad',
      selector: (row) => (
        <div className="flex flex-row ">

          <div className='flex flex-row ml-2 items-center'>

            <img src={row.currency_code == "COP" ? COPU : USD} className="w-4 h-4 mr-2" alt="" />
            <span className="text-gray-400 text-sm">{row.category_text === "Send" ? "-" : "+"} {FormatMontoPSE(row.amount, false, row.currency_code == "COP" ? "," : ".")} </span>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Usuario',
      selector: (row) => {

        return row.category_text === "Send" ? row.details.to_user_username : row.category_text === "Receive" ? row.details.from_user_username : row.user.email;
      }, sortable: true,
    },
    {
      name: 'Tipo',
      selector: (row) => {
        const categoryMap = {
          Convert: "Convertiste",
          Send: "Enviaste",
          Receive: "Recibiste",
          Reload: "Recargaste",
          Dispersion: "Enviaste",
        };
        return categoryMap[row.category_text] || "";
      }, sortable: true,
    },
    {
      name: 'Estado',
      cell: (row) => (
        <div className={`text-xs px-3 py-1 rounded-full font-medium ${row.status_text === 'Approved' ? 'bg-[#BDFFFF] text-black' : row.status_text === "Rejected" ? 'bg-[#e4847f] text-black' : 'bg-[#FAECDC] text-black'}`}>
          {row.status_text === "Approved" ? "Aprobado" : row.status_text === "Rejected" ? "Rechazado" : "Pendiente"}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Fecha y hora',
      cell: (row) => (
        <div className="flex items-center gap-2 text-gray-400">
          <FaRegCalendarAlt size={14} />
          {moment(row?.created).format("DD/MM/YY")}
          <FaRegClock size={14} />
          {moment(row.created).format("hh:mm a")}
        </div>
      ),
      sortable: true,
    },


  ];
  const MovementsListPage = async (page) => {
    setLoadingTable(true)
    try {
      const response = await axios.post(`/api/movements`, {
        headers: await getAuthenticatedHeaders(),
        page: page,
        currency: currencyCoin
      });
      setDataTable(response.data?.data?.items)
      setTotalRows(response.data?.data?.total_items)

    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
    setLoadingTable(false)

  };


  const handlePageChange = page => {
    MovementsListPage(page);
  };
  useEffect(() => {
    CurrencyCoin()
    BalanceWalletCredit()
    MovementsList()
    WalletBalanceHome()
  }, [currencyCoin])



  return (
    <div className="home">
      <ModalDepositar
        currencyCoin={currencyCoin}
        MovementsList={MovementsList}
        pasesito={3}
        WalletBalanceHome={WalletBalanceHome}
        balanceWalletCop={balanceWalletCop}
        balanceWalletUsd={balanceWalletUsd}
        activeDepositar={activeDepositar}
        setActiveDepositar={setActiveDepositar}
      />
      <ModalExchange
        currencyCoin={currencyCoin}

        MovementsList={MovementsList}
        WalletBalanceHome={WalletBalanceHome}
        balanceWalletCop={balanceWalletCop}
        balanceWalletUsd={balanceWalletUsd}
        activeExchange={activeExchange}
        setActiveExchange={setActiveExchange}
      />
      <ModalSend
        currencyCoin={currencyCoin}
        MovementsList={MovementsList}
        pasesito={1}
        WalletBalanceHome={WalletBalanceHome}
        balanceWalletCop={balanceWalletCop}
        balanceWalletUsd={balanceWalletUsd}
        activeDepositar={activeSend}
        setActiveDepositar={setActiveSend}
      />
      <ModalReceibe
        pasesito={1}
        currencyCoin={currencyCoin}
        WalletBalanceHome={WalletBalanceHome}
        balanceWalletCop={balanceWalletCop}
        balanceWalletUsd={balanceWalletUsd}
        activeDepositar={Recibe}
        setActiveDepositar={setRecibe}
      />
      <div className='w-full flex flex-col h-[100vh]  py-10 pr-3  gap-2  ' >
        <div className='w-full flex justify-between text-center' >
          <div className='flex flex-col justify-end'  >
            <h2 style={{ fontSize: 24, fontWeight: '700', letterSpacing: -0.48, fontStyle: 'normal', color: 'white' }}>Mis cuentas</h2>
          </div>
        </div>
        <div className='w-full   flex flex-row gap-2 ' >
          <div className='gap-2 flex flex-col bg-[#1B1B22] rounded-xl h-full p-2 items-center' style={{ width: '8%' }}>
            {data.map((data) => (
              <ButtonWalletCripto currencyCoin={currencyCoin} setCurrencyCoin={setCurrencyCoin} bgColor='#26262D' data={data} imageSrc={data.image} label={data.code} />
            ))}

          </div>
          <div className=' flex flex-col ' style={{ width: '92%', gap: 8 }}>
            <div className='w-full gap-2 flex flex-row '>
              <div style={{ width: '33%', height: 'auto' }} >
                <CardWalletBalance loading={LoadingBalance} balance={FormatMontoPSE(dataAmount.balance, false, currencyCoin === "COP" ? "," : ".")} />
              </div>
              <div style={{ width: '33%', height: 'auto' }} >
                <CardWalletBalance loading={LoadingBalance} colorlabel={'#2DA8A8'} label='Créditos' balance={FormatMontoPSE(dataAmount.total_credits, false, currencyCoin === "COP" ? "," : ".")} />
              </div>
              <div style={{ width: '33%', height: 'auto' }} >
                <CardWalletBalance loading={LoadingBalance} colorlabel={'#FF928B'} label='Débitos' balance={FormatMontoPSE(dataAmount.total_debits, false, currencyCoin === "COP" ? "," : ".")} />
              </div>
              <div className=' flex flex-row ' style={{ width: '20%' }}>
                <div className="w-full h-full items-center justify-center  grid grid-cols-2 gap-2">
                  <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8'} title={'Depositar'} onClick={() => OpenDepositar()} />
                  <ButtonHomeTransaction loading={LoadingBalance} Icon={TbTransfer} classNameIcon={'size-7'} title={'Convertir'} onClick={() => setActiveExchange(true)} />
                  <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8 rotate-[220deg] '} onClick={() => setActiveSend(true)} title={'Enviar'} />
                  <ButtonHomeTransaction loading={LoadingBalance} Icon={IoIosArrowRoundDown} classNameIcon={'size-8 rotate-45 '} title={'Recibir'} onClick={() => OpenReceibe()} />
                </div>
              </div>

            </div>
            <div className='w-full h-auto flex gap-2 ' >

              <CustomTable totalRows={TotalRows} loadingTable={LoadingTableSkeleton} data={DataTable} columns={columns} handlePageChange={handlePageChange} pending={LoadingTable} filterActive={false} downloadActive={false} datos={true} seeMoreActive={true} />

            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default MyWallet;
